import React from "react";
import { Form } from "react-bootstrap";

const PracticalQuestion = React.memo(({ index, input, onStoryBoardTitleChange, onStoryBoardInfoChange, onTaskTitleChange, onTaskInfoChange, removeHandler }) => {

    return (
        <Form>
            <div className="d-flex px-3">
                <label className="pt-2">Question No: {index + 1}</label>
                <div className="ms-auto">
                    {index > 0 && (
                        <button
                            type="button"
                            title="Remove Question"
                            className="btn btn-sm btn-outline-danger pt-2"
                            onClick={() => removeHandler(input.id)}
                        >
                            <i className="pi pi-times"></i>
                        </button>
                    )}
                </div>
            </div>
            <hr className="mx-3"></hr>
            <div className="row px-3">
                <div className="col-12">
                    <label className="fw-light form-label">Story Board Title</label>
                </div>
            </div>
            <div className="row mb-3 px-3">
                <div className="col-12 mb-1">
                    <input
                        className="form-control question custom-input custom-input-color"
                        defaultValue={input && input.storyBoardTitle}
                        onChange={(e) => onStoryBoardTitleChange(input.id, e.target.value)}
                    ></input>
                </div>
            </div>
            <div className="row px-3">
                <div className="col-12">
                    <label className=" fw-light form-label">Story Board Info</label>
                </div>
            </div>
            <div className="row mb-3 px-3">
                <div className="col-12">
                    <textarea
                        className="form-control custom-input-color py-2"
                        defaultValue={input && input.storyBoardInfo}
                        style={{
                            minHeight: '200px',
                            maxHeight: '350px'
                        }}
                        onChange={(e) => onStoryBoardInfoChange(input.id, e.target.value)}
                    ></textarea>
                </div>
            </div>
            <div className="row px-3">
                <div className="col-12">
                    <label className=" fw-light form-label">Task Title</label>
                </div>
            </div>
            <div className="row mb-3 px-3">
                <div className="col-12">
                    <input
                        className="form-control custom-input question custom-input-color"
                        defaultValue={input && input.taskTitle}
                        onChange={(e) => onTaskTitleChange(input.id, e.target.value)}
                    ></input>
                </div>
            </div>
            <div className="row px-3">
                <div className="col-12">
                    <label className="fw-light form-label">Task Info</label>
                </div>
            </div>
            <div className="row mb-4 px-3">
                <div className="col-12">
                    <input
                        className="form-control custom-input custom-input-color"
                        defaultValue={input && input.taskInfo}
                        onChange={(e) => onTaskInfoChange(input.id, e.target.value)}
                    ></input>
                </div>
            </div>
            <hr className="mx-3"></hr>
        </Form>
    );
});

export default PracticalQuestion;
